"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ranges = undefined;

var _icon = require("@alicd/next/lib/icon");

var _icon2 = _interopRequireDefault(_icon);

var _input = require("@alicd/next/lib/input");

var _input2 = _interopRequireDefault(_input);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _button = require("@alicd/next/lib/button");

var _button2 = _interopRequireDefault(_button);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _grid = require("@alicd/next/lib/grid");

var _grid2 = _interopRequireDefault(_grid);

var _overlay = require("@alicd/next/lib/overlay");

var _overlay2 = _interopRequireDefault(_overlay);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require("@alicd/next/lib/_components/@alicd/next-date-picker/lib/view/utils");

var _boundUtils = require("./boundUtils");

var _RangePickerSidePanel = require("./RangePickerSidePanel");

var _RangePickerSidePanel2 = _interopRequireDefault(_RangePickerSidePanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Popup = _overlay2.default.Popup;
var Row = _grid2.default.Row,
    Col = _grid2.default.Col;
var ranges = exports.ranges = function ranges(src) {
    var closesOverlay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return function (_ref) {
        var setValue = _ref.setValue,
            setVisible = _ref.setVisible;
        return _react2.default.createElement(
            Row,
            { type: "no-padding", className: "cn-range-picker-ranges" },
            src.map(function (_ref2, index) {
                var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
                    name = _ref3[0],
                    value = _ref3[1];

                return _react2.default.createElement(
                    Col,
                    { key: index },
                    _react2.default.createElement(
                        _button2.default,
                        {
                            shape: "text",
                            size: "small",
                            onClick: function onClick() {
                                setValue(value);
                                if (closesOverlay) {
                                    setVisible(false);
                                }
                            }
                        },
                        name
                    )
                );
            })
        );
    };
};

function getRangeValue(values, dateFormat, disabledDate) {
    if (!Array.isArray(values)) {
        return [null, null];
    }

    var startValue = (0, _utils.toMoment)(values[0], dateFormat, disabledDate);
    var endValue = (0, _utils.toMoment)(values[1], dateFormat, disabledDate);

    return [startValue, endValue];
}

var DateRangePicker = function (_React$Component) {
    (0, _inherits3.default)(DateRangePicker, _React$Component);

    function DateRangePicker(props) {
        (0, _classCallCheck3.default)(this, DateRangePicker);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DateRangePicker.__proto__ || (0, _getPrototypeOf2.default)(DateRangePicker)).call(this, props));

        _this.state = {
            visible: typeof props.visible != "undefined" ? props.visible : props.defaultVisible,
            wrappedDisabledDate: (0, _boundUtils.wrapDisabledDateWithBound)(props.disabledDate, props)
        };

        _this.format = (0, _utils.getFormat)(props.formater, props.format, props.showTime);

        _this.state.value = getRangeValue(props.value || props.defaultValue, _this.format.dateTimeFormat, _this.state.wrappedDisabledDate);

        _this.updateBoundProps(props);

        _this.handleStartChange = _this.handleChange.bind(_this, 0);
        _this.handleEndChange = _this.handleChange.bind(_this, 1);
        _this.handleClearValue = _this.handleClearValue.bind(_this);
        _this.handleVisibleChange = _this.handleVisibleChange.bind(_this);
        _this.handleOk = _this.handleVisibleChange.bind(_this, false);

        _this.getValue = _this.getValue.bind(_this);
        _this.setValue = _this.setValue.bind(_this);
        _this.setVisible = _this.setVisible.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(DateRangePicker, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            var wrappedDisabledDate = (0, _boundUtils.wrapDisabledDateWithBound)(nextProps.disabledDate, nextProps);
            if ("value" in nextProps) {

                this.format = (0, _utils.getFormat)(nextProps.formater, nextProps.format, nextProps.showTime);

                var newValue = getRangeValue(nextProps.value, this.dateTimeFormat, wrappedDisabledDate);

                this.setState({ value: newValue, wrappedDisabledDate: wrappedDisabledDate });
            }
            if ("visible" in nextProps) {
                this.setState({ visible: nextProps.visible });
            }

            this.updateBoundProps(nextProps);
        }
    }, {
        key: "getValue",
        value: function getValue() {
            return [].concat((0, _toConsumableArray3.default)(this.state.value));
        }
    }, {
        key: "setValue",
        value: function setValue(value) {
            var newValue = getRangeValue(value, this.dateTimeFormat, this.state.wrappedDisabledDate);
            this.setState({ value: newValue });
        }
    }, {
        key: "setVisible",
        value: function setVisible(visible) {
            this.handleVisibleChange(visible);
        }
    }, {
        key: "updateBoundProps",
        value: function updateBoundProps() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            this._altLowerBound = props.altLowerBound && (0, _utils.toMoment)(props.altLowerBound);
            this._altUpperBound = props.altUpperBound && (0, _utils.toMoment)(props.altUpperBound);
        }
    }, {
        key: "handleChange",
        value: function handleChange(idx, value) {
            var _this2 = this;

            var newValue = [].concat((0, _toConsumableArray3.default)(this.state.value));
            newValue[idx] = value;
            if (!("value" in this.props)) {
                this.setState({ value: newValue });
            }

            if (typeof this.props.onChange === "function") {
                var showTime = this.props.showTime;

                var valueParts = newValue.map(function (v) {
                    return (0, _utils.parseDateParts)(v, _this2.format.dateFormat, _this2.format.timeFormat, _this2.format.dateTimeFormat);
                });

                var formatStrings = valueParts.map(showTime ? function (v) {
                    return v.dateTimeString;
                } : function (v) {
                    return v.dateString;
                });
                this.props.onChange(valueParts.map(function (v) {
                    return v.dateValue;
                }), formatStrings);
            }
        }
    }, {
        key: "handleClearValue",
        value: function handleClearValue(e) {
            var _this3 = this;

            e.stopPropagation();
            this.setState({ value: [null, null] }, function () {
                _this3.props.onChange && _this3.props.onChange(null, null);
            });
        }
    }, {
        key: "handleVisibleChange",
        value: function handleVisibleChange(visible) {
            if (!("visible" in this.props)) {
                this.setState({ visible: visible });
            }
            typeof this.props.onVisibleChange == "function" && this.props.onVisibleChange(visible);
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this,
                _classNames;

            var _props = this.props,
                className = _props.className,
                style = _props.style,
                id = _props.id,
                size = _props.size,
                showTime = _props.showTime,
                disabledDate = _props.disabledDate,
                disabledHours = _props.disabledHours,
                disabledMinutes = _props.disabledMinutes,
                disabledSeconds = _props.disabledSeconds,
                popupAlign = _props.popupAlign,
                popupStyle = _props.popupStyle,
                popupOffset = _props.popupOffset,
                popupClassName = _props.popupClassName,
                hasClear = _props.hasClear,
                locale = _props.locale,
                disabled = _props.disabled,
                startDisabled = _props.startDisabled,
                endDisabled = _props.endDisabled,
                readOnly = _props.readOnly,
                resetTime = _props.resetTime,
                renderQuickTool = _props.renderQuickTool,
                rest = (0, _objectWithoutProperties3.default)(_props, ["className", "style", "id", "size", "showTime", "disabledDate", "disabledHours", "disabledMinutes", "disabledSeconds", "popupAlign", "popupStyle", "popupOffset", "popupClassName", "hasClear", "locale", "disabled", "startDisabled", "endDisabled", "readOnly", "resetTime", "renderQuickTool"]);


            var iconSize = {
                large: 'medium',
                medium: 'small',
                small: 'xs'
            }[size];

            var panelClassNames = (0, _classnames2.default)({
                "next-range-picker-panel": true,
                "cn-range-picker-panel": true,
                "next-range-picker-panel-show-time": showTime
            }, popupClassName);

            var datePanel = _react2.default.createElement(
                "div",
                { className: panelClassNames, style: popupStyle },
                _react2.default.createElement(
                    "div",
                    { className: "cn-range-picker-body" },
                    _react2.default.createElement(_RangePickerSidePanel2.default, {
                        showTime: showTime,
                        value: this.state.value[0],
                        onChange: this.handleStartChange,
                        format: this.format,
                        disabledDate: disabledDate,
                        disabledHours: disabledHours,
                        disabledMinutes: disabledMinutes,
                        disabledSeconds: disabledSeconds,
                        disabled: disabled || startDisabled,
                        readOnly: readOnly,
                        size: size,
                        resetTime: resetTime,
                        idx: 0,
                        altLowerBound: this._altLowerBound,
                        altUpperBound: this.state.value[1]
                    }),
                    _react2.default.createElement(_RangePickerSidePanel2.default, {
                        showTime: showTime,
                        value: this.state.value[1],
                        onChange: this.handleEndChange,
                        format: this.format,
                        disabledDate: disabledDate,
                        disabledHours: disabledHours,
                        disabledMinutes: disabledMinutes,
                        disabledSeconds: disabledSeconds,
                        disabled: disabled || endDisabled,
                        readOnly: readOnly,
                        size: size,
                        resetTime: resetTime,
                        idx: 1,
                        altLowerBound: this.state.value[0],
                        altUpperBound: this._altUpperBound
                    })
                ),
                _react2.default.createElement(
                    Row,
                    { className: "next-date-picker-quick-tool cn-range-picker-toolbar" },
                    _react2.default.createElement(
                        Col,
                        null,
                        typeof renderQuickTool == "function" ? renderQuickTool(this) : null
                    ),
                    _react2.default.createElement(
                        _button2.default,
                        { className: "cn-range-picker-ok", type: "primary", size: "small", onClick: this.handleOk },
                        "\u786E\u5B9A"
                    )
                )
            );

            var parts = this.state.value.map(function (x) {
                return (0, _utils.parseDateParts)(x, _this4.format.dateFormat, _this4.format.timeFormat, _this4.format.dateTimeFormat);
            });

            var triggerClassNames = (0, _classnames2.default)((_classNames = {
                "next-date-picker": true,
                "next-range-picker": true
            }, (0, _defineProperty3.default)(_classNames, "next-range-picker-" + size, true), (0, _defineProperty3.default)(_classNames, "next-range-picker-show-time", showTime), _classNames), className);

            var trigger = _react2.default.createElement(
                "div",
                { className: triggerClassNames, style: style, id: id },
                _react2.default.createElement(
                    "div",
                    { className: "next-range-picker-trigger" },
                    _react2.default.createElement(_input2.default, {
                        value: showTime ? parts[0].dateTimeString : parts[0].dateString,
                        placeholder: locale.rangeStartPlaceholder,
                        disabled: disabled || startDisabled,
                        readOnly: readOnly,
                        size: size
                    }),
                    _react2.default.createElement(
                        "div",
                        { className: "next-range-picker-separator" },
                        "\u2013"
                    ),
                    _react2.default.createElement(_input2.default, {
                        value: showTime ? parts[1].dateTimeString : parts[1].dateString,
                        placeholder: locale.rangeEndPlaceholder,
                        disabled: disabled || endDisabled,
                        readOnly: readOnly,
                        size: size
                    })
                ),
                (this.state.value[0] || this.state.value[1]) && !disabled && hasClear ? _react2.default.createElement(_icon2.default, { type: "delete-filling", size: iconSize, title: locale.clear, onClick: this.handleClearValue.bind(this) }) : _react2.default.createElement(_icon2.default, { type: "calendar", size: iconSize })
            );

            return _react2.default.createElement(
                Popup,
                {
                    trigger: trigger,
                    triggerType: "click",
                    align: popupAlign,
                    offset: popupOffset,
                    disabled: disabled,
                    visible: this.state.visible,
                    onVisibleChange: this.handleVisibleChange
                },
                datePanel
            );
        }
    }]);
    return DateRangePicker;
}(_react2.default.Component);

DateRangePicker.propTypes = {
    className: _propTypes2.default.string,
    value: _propTypes2.default.array,
    defaultValue: _propTypes2.default.array,
    onChange: _propTypes2.default.func,
    hasClear: _propTypes2.default.bool,
    size: _propTypes2.default.oneOf(["small", "medium", "large"]),
    showTime: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]),
    visible: _propTypes2.default.bool,
    defaultVisible: _propTypes2.default.bool,
    onVisibleChange: _propTypes2.default.func,
    disabledDate: _propTypes2.default.func,
    disabledHours: _propTypes2.default.func,
    disabledMinutes: _propTypes2.default.func,
    disabledSeconds: _propTypes2.default.func,
    formater: _propTypes2.default.array,
    popupClassName: _propTypes2.default.string,
    popupAlign: _propTypes2.default.string,
    popupStyle: _propTypes2.default.object,
    popupOffset: _propTypes2.default.array,
    disabled: _propTypes2.default.bool,
    readOnly: _propTypes2.default.bool,
    resetTime: _propTypes2.default.bool,
    startDisabled: _propTypes2.default.bool,
    endDisabled: _propTypes2.default.bool,
    altLowerBound: _propTypes2.default.any,
    altUpperBound: _propTypes2.default.any,
    renderQuickTool: _propTypes2.default.func
};
DateRangePicker.defaultProps = {
    hasClear: true,
    size: "medium",
    formater: ['YYYY-MM-DD', 'HH:mm:ss'],
    showTime: false,
    disabledDate: function disabledDate() {
        return false;
    },
    popupAlign: "tl tl",
    disabled: false,
    readOnly: false,
    resetTime: true,
    defaultVisible: false,
    startDisabled: false,
    endDisabled: false
};
exports.default = DateRangePicker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-date-range-picker@0.0.3@@alicd/crui-date-range-picker/lib/RangePicker.js
// module id = 621
// module chunks = 0